import {AbstractCode} from 'src/codes/abstract';

/**
 * slstempitem.Item_MST.released（0/1）
 */
const CodeList = [
  {
    id: 0,
    value: '未公開',
  },
  {
    id: 1,
    value: '公開済み',
  },
] as const;

export type FundReleased = typeof CodeList[number];

const CodeClass = new AbstractCode(CodeList);

const NameAccessor = CodeList.reduce(
  (result, elem) => {
    result[elem.value] = elem;
    return result;
  },
  {} as Record<FundReleased['value'], FundReleased>,
);

export const FundReleased = Object.assign(CodeClass, NameAccessor);
